import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcccb196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "希望条件の編集")
], -1))
const _hoisted_3 = { class: "careersheet_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_requirements_title_label" }, "希望業種"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/102",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）業種一覧 ")
], -1))
const _hoisted_5 = { class: "careersheet_requirements_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第1希望"),
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_required" }, "必須")
], -1))
const _hoisted_7 = { class: "careersheet_requirements_item_input" }
const _hoisted_8 = { class: "careersheet_requirements_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第2希望")
], -1))
const _hoisted_10 = { class: "careersheet_requirements_item_input" }
const _hoisted_11 = {
  key: 0,
  class: "careersheet_requirements_item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第3希望")
], -1))
const _hoisted_13 = { class: "careersheet_requirements_item_input" }
const _hoisted_14 = {
  key: 1,
  class: "careersheet_requirements_item"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第4希望")
], -1))
const _hoisted_16 = { class: "careersheet_requirements_item_input" }
const _hoisted_17 = {
  key: 2,
  class: "careersheet_requirements_item"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第5希望")
], -1))
const _hoisted_19 = { class: "careersheet_requirements_item_input" }
const _hoisted_20 = {
  key: 3,
  class: "careersheet_requirements_item"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第6希望")
], -1))
const _hoisted_22 = { class: "careersheet_requirements_item_input" }
const _hoisted_23 = {
  key: 4,
  class: "careersheet_requirements_add"
}
const _hoisted_24 = { class: "careersheet_input" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_requirements_title_label" }, "希望職種"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/101",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）職種一覧 ")
], -1))
const _hoisted_26 = { class: "careersheet_requirements_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第1希望"),
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_required" }, "必須")
], -1))
const _hoisted_28 = { class: "careersheet_requirements_item_input" }
const _hoisted_29 = { class: "careersheet_requirements_item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第2希望")
], -1))
const _hoisted_31 = { class: "careersheet_requirements_item_input" }
const _hoisted_32 = {
  key: 0,
  class: "careersheet_requirements_item"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第3希望")
], -1))
const _hoisted_34 = { class: "careersheet_requirements_item_input" }
const _hoisted_35 = {
  key: 1,
  class: "careersheet_requirements_item"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第4希望")
], -1))
const _hoisted_37 = { class: "careersheet_requirements_item_input" }
const _hoisted_38 = {
  key: 2,
  class: "careersheet_requirements_item"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第5希望")
], -1))
const _hoisted_40 = { class: "careersheet_requirements_item_input" }
const _hoisted_41 = {
  key: 3,
  class: "careersheet_requirements_item"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第6希望")
], -1))
const _hoisted_43 = { class: "careersheet_requirements_item_input" }
const _hoisted_44 = {
  key: 4,
  class: "careersheet_requirements_add"
}
const _hoisted_45 = { class: "careersheet_input" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_requirements_title_label" }, "希望勤務地")
], -1))
const _hoisted_47 = { class: "careersheet_requirements_item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第1希望"),
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_required" }, "必須")
], -1))
const _hoisted_49 = { class: "careersheet_requirements_item_input" }
const _hoisted_50 = { class: "careersheet_requirements_item" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第2希望")
], -1))
const _hoisted_52 = { class: "careersheet_requirements_item_input" }
const _hoisted_53 = {
  key: 0,
  class: "careersheet_requirements_item"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第3希望")
], -1))
const _hoisted_55 = { class: "careersheet_requirements_item_input" }
const _hoisted_56 = {
  key: 1,
  class: "careersheet_requirements_item"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "careersheet_requirements_item_label_text" }, "第4希望")
], -1))
const _hoisted_58 = { class: "careersheet_requirements_item_input" }
const _hoisted_59 = {
  key: 2,
  class: "careersheet_requirements_add"
}
const _hoisted_60 = { class: "entry_career_input" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "希望年収"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_62 = { class: "careersheet_input_layout_column_2" }
const _hoisted_63 = { class: "careersheet_input_item_text_column_2_left" }
const _hoisted_64 = { class: "careersheet_input_layout_column_2_item_inner" }
const _hoisted_65 = { class: "careersheet_input_item_text_column_2_inner_input" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_item_text_column_2_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_input_item_text_column_2_inner_suffix_text" }, "万円")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_item_text_column_2_right" }, null, -1))
const _hoisted_68 = { class: "careersheet_input" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "転職希望時期"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_70 = { class: "careersheet_input_layout_column_1" }
const _hoisted_71 = { class: "provision_input" }
const _hoisted_72 = { class: "careersheet_input" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "雇用形態（複数選択可）"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_74 = { class: "careersheet_input_layout_column_2" }
const _hoisted_75 = { class: "careersheet_input" }
const _hoisted_76 = /*#__PURE__*/_createStaticVNode("<div class=\"input_title\" data-v-dcccb196><span class=\"input_title_label\" data-v-dcccb196>ご希望条件の詳細</span></div><div class=\"input_title\" data-v-dcccb196><span class=\"input_title_label\" data-v-dcccb196>※気になる求人がありましたら、求人IDをご入力ください</span></div><div class=\"input_title\" data-v-dcccb196><span class=\"input_title_label\" data-v-dcccb196>※マスメディアンへのご要望がありましたら、ご入力ください</span></div>", 3)
const _hoisted_79 = { class: "careersheet_input_layout_column_1" }
const _hoisted_80 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_81 = { class: "careersheet_button" }
const _hoisted_82 = { class: "careersheet_button_prev" }
const _hoisted_83 = { class: "careersheet_button_next" }

import BaseButton from '@/components/BaseButton.vue';
import EditRadioModal from '@/components/EditRadioModal.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import BaseSelectBox from '@/components/BaseSelectBox.vue';
import BaseSelectButton from '@/components/BaseSelectButton.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import { ref, Ref, computed } from 'vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';
import { useField, useForm } from 'vee-validate';
import { object, string, boolean, number } from 'yup';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import BaseTextForm from '@/components/BaseTextForm.vue';
type ChangeDateConvert = {
  value: number;
  label: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'DesiredEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const schema = object({
  desiredCondition: object({
    wishIndsctg1Id: number().nullable().label('希望業種の第1希望').required(VALIDATON_ERRORS.REQUIRED),
    wishOcupctg1Id: string().nullable().label('希望職種の第1希望').required(VALIDATON_ERRORS.REQUIRED),
    wishWkarea1Id: number().nullable().label('希望勤務地の第1希望').required(VALIDATON_ERRORS.REQUIRED),
    empTypeFlg1: boolean()
      .nullable()
      .label('雇用形態')
      .test('desiredCondition.empTypeFlg1', VALIDATON_ERRORS.REQUIRED, function (value) {
        return this.parent.empTypeFlg5 || value;
      }),
    empTypeFlg5: boolean()
      .nullable()
      .label('雇用形態')
      .test('desiredCondition.empTypeFlg5', VALIDATON_ERRORS.REQUIRED, function (value) {
        return this.parent.empTypeFlg1 || value;
      }),
    demand: string().nullable().label('ご希望条件の詳細').max(2000, VALIDATON_ERRORS.MAX_LENGTH),
    wishAnnualIncomeNum: number()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .typeError('希望年収は半角数字で入力してください')
      .nullable()
      .required('希望年収は必須です'),

     wishJobChangeDateId: string().nullable().label('転職希望時期').required('転職希望時期は必須です'),

  }),
});

const { meta, errors } = useForm({
  validationSchema: schema,
});
const wishIndsctg1IdErrors = computed(() =>
  errors.value['desiredCondition.wishIndsctg1Id'] ? [errors.value['desiredCondition.wishIndsctg1Id']] : []
);
const wishOcupctg1IdErrors = computed(() =>
  errors.value['desiredCondition.wishOcupctg1Id'] ? [errors.value['desiredCondition.wishOcupctg1Id']] : []
);
const wishWkarea1IdErrors = computed(() =>
  errors.value['desiredCondition.wishWkarea1Id'] ? [errors.value['desiredCondition.wishWkarea1Id']] : []
);
const empTypeFlg1Errors = computed(() =>
  errors.value['desiredCondition.empTypeFlg1'] ? [errors.value['desiredCondition.empTypeFlg1']] : []
);
const demandErrors = computed(() => (errors.value['desiredCondition.demand'] ? [errors.value['desiredCondition.demand']] : []));
const wishAnnualIncomeNumErrors = computed(() => (errors.value['desiredCondition.wishAnnualIncomeNum'] ? [errors.value['desiredCondition.wishAnnualIncomeNum']] : []));
const wishJobChangeDateIdErrors = computed(() => (errors.value['desiredCondition.wishJobChangeDateId'] ? [errors.value['desiredCondition.wishJobChangeDateId']] : []));

const { value: desiredCondition } = useField('desiredCondition', undefined, {
  initialValue: store.getters['careerSheetDesired/desiredCondition'],
});

const mstListPrefOptions: Ref<{ label: string; value: number }[]> = computed(() => store.getters['master/mstListPrefOptions']);
const mstIndsctgRadioOnlyList = computed(() => store.getters['master/mstIndsctgRadioOnlyList']);
const mstIndsctgFlat = computed(() => store.getters['master/mstIndsctgFlat']);
const mstOcupClassRadioList = computed(() => store.getters['master/mstOcupClassRadioList']);
const mstOcupClassFlat = computed(() => store.getters['master/mstOcupClassFlat']);
const mstWishJobChangeDateId: Ref<{ code: number; name: string }[]> = computed(() =>
  store.getters['master/mstWishJobChangeDateId']);

// 業種
const maxWishIndsctgIndex = ref(2);

const shownIndsctg1Modal = ref(false);
const openIndsctg1Modal = () => (shownIndsctg1Modal.value = true);
const closeIndsctg1Modal = () => (shownIndsctg1Modal.value = false);
const wishIndsctg1Name = computed({
  get: () => (desiredCondition.value.wishIndsctg1Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg1Id] : ''),
  set: () => (desiredCondition.value.wishIndsctg1Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg1Id] : ''),
});

const shownIndsctg2Modal = ref(false);
const openIndsctg2Modal = () => (shownIndsctg2Modal.value = true);
const closeIndsctg2Modal = () => (shownIndsctg2Modal.value = false);
const wishIndsctg2Name = computed({
  get: () => (desiredCondition.value.wishIndsctg2Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg2Id] : ''),
  set: () => (desiredCondition.value.wishIndsctg2Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg2Id] : ''),
});

const shownIndsctg3Modal = ref(false);
const openIndsctg3Modal = () => (shownIndsctg3Modal.value = true);
const closeIndsctg3Modal = () => (shownIndsctg3Modal.value = false);
const wishIndsctg3Name = computed({
  get: () => (desiredCondition.value.wishIndsctg3Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg3Id] : ''),
  set: () => (desiredCondition.value.wishIndsctg3Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg3Id] : ''),
});

const shownIndsctg4Modal = ref(false);
const openIndsctg4Modal = () => (shownIndsctg4Modal.value = true);
const closeIndsctg4Modal = () => (shownIndsctg4Modal.value = false);
const wishIndsctg4Name = computed({
  get: () => (desiredCondition.value.wishIndsctg4Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg4Id] : ''),
  set: () => (desiredCondition.value.wishIndsctg4Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg4Id] : ''),
});

const shownIndsctg5Modal = ref(false);
const openIndsctg5Modal = () => (shownIndsctg5Modal.value = true);
const closeIndsctg5Modal = () => (shownIndsctg5Modal.value = false);
const wishIndsctg5Name = computed({
  get: () => (desiredCondition.value.wishIndsctg5Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg5Id] : ''),
  set: () => (desiredCondition.value.wishIndsctg5Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg5Id] : ''),
});

const shownIndsctg6Modal = ref(false);
const openIndsctg6Modal = () => (shownIndsctg6Modal.value = true);
const closeIndsctg6Modal = () => (shownIndsctg6Modal.value = false);
const wishIndsctg6Name = computed({
  get: () => (desiredCondition.value.wishIndsctg6Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg6Id] : ''),
  set: () => (desiredCondition.value.wishIndsctg6Id ? mstIndsctgFlat.value[desiredCondition.value.wishIndsctg6Id] : ''),
});

// 職種
const maxOcupctgIndex = ref(2);

const shownOcupctg1Modal = ref(false);
const openOcupctg1Modal = () => (shownOcupctg1Modal.value = true);
const closeOcupctg1Modal = () => (shownOcupctg1Modal.value = false);
const wishOcupctg1Name = computed({
  get: () => (desiredCondition.value.wishOcupctg1Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg1Id] : ''),
  set: () => (desiredCondition.value.wishOcupctg1Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg1Id] : ''),
});

const shownOcupctg2Modal = ref(false);
const openOcupctg2Modal = () => (shownOcupctg2Modal.value = true);
const closeOcupctg2Modal = () => (shownOcupctg2Modal.value = false);
const wishOcupctg2Name = computed({
  get: () => (desiredCondition.value.wishOcupctg2Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg2Id] : ''),
  set: () => (desiredCondition.value.wishOcupctg2Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg2Id] : ''),
});

const shownOcupctg3Modal = ref(false);
const openOcupctg3Modal = () => (shownOcupctg3Modal.value = true);
const closeOcupctg3Modal = () => (shownOcupctg3Modal.value = false);
const wishOcupctg3Name = computed({
  get: () => (desiredCondition.value.wishOcupctg3Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg3Id] : ''),
  set: () => (desiredCondition.value.wishOcupctg3Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg3Id] : ''),
});

const shownOcupctg4Modal = ref(false);
const openOcupctg4Modal = () => (shownOcupctg4Modal.value = true);
const closeOcupctg4Modal = () => (shownOcupctg4Modal.value = false);
const wishOcupctg4Name = computed({
  get: () => (desiredCondition.value.wishOcupctg4Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg4Id] : ''),
  set: () => (desiredCondition.value.wishOcupctg4Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg4Id] : ''),
});

const shownOcupctg5Modal = ref(false);
const openOcupctg5Modal = () => (shownOcupctg5Modal.value = true);
const closeOcupctg5Modal = () => (shownOcupctg5Modal.value = false);
const wishOcupctg5Name = computed({
  get: () => (desiredCondition.value.wishOcupctg5Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg5Id] : ''),
  set: () => (desiredCondition.value.wishOcupctg5Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg5Id] : ''),
});

const shownOcupctg6Modal = ref(false);
const openOcupctg6Modal = () => (shownOcupctg6Modal.value = true);
const closeOcupctg6Modal = () => (shownOcupctg6Modal.value = false);
const wishOcupctg6Name = computed({
  get: () => (desiredCondition.value.wishOcupctg6Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg6Id] : ''),
  set: () => (desiredCondition.value.wishOcupctg6Id ? mstOcupClassFlat.value[desiredCondition.value.wishOcupctg6Id] : ''),
});

const maxWishWkareaIndex = ref(2);

const changeDateConvert = computed<ChangeDateConvert[]>(() =>
  mstWishJobChangeDateId.value.map((item) => ({
    value: item.code,
    label: item.name,
  }))
);

const selectedChangeDateValue = computed({
  get: () => desiredCondition.value.wishJobChangeDateId ? Number(desiredCondition.value.wishJobChangeDateId) : null,
  set: (val: number | null) => {
    desiredCondition.value.wishJobChangeDateId = val !== null ? String(val) : null;
  },
});

const init = () => {
  // この辺でvalueがうまく設定されてないぽい null以外が入ってきてる？
  if (desiredCondition.value.wishWkarea4Id) {
    maxWishWkareaIndex.value = 4;
  } else if (desiredCondition.value.wishWkarea3Id) {
    maxWishWkareaIndex.value = 3;
  }

  if (desiredCondition.value.wishIndsctg6Id) {
    maxWishIndsctgIndex.value = 6;
  } else if (desiredCondition.value.wishIndsctg5Id) {
    maxWishIndsctgIndex.value = 5;
  } else if (desiredCondition.value.wishIndsctg4Id) {
    maxWishIndsctgIndex.value = 4;
  } else if (desiredCondition.value.wishIndsctg3Id) {
    maxWishIndsctgIndex.value = 3;
  }

  if (desiredCondition.value.wishOcupctg6Id) {
    maxOcupctgIndex.value = 6;
  } else if (desiredCondition.value.wishOcupctg5Id) {
    maxOcupctgIndex.value = 5;
  } else if (desiredCondition.value.wishOcupctg4Id) {
    maxOcupctgIndex.value = 4;
  } else if (desiredCondition.value.wishOcupctg3Id) {
    maxOcupctgIndex.value = 3;
  }
};

const searchableOrder = store.getters['userMenu/searchableOrder'];
desiredCondition.value.careersheetUpdateFlg = searchableOrder;

init();

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e40', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n40' });
  }
};

const transitionConfirmPage = () => {
  store.commit('careerSheetDesired/setDesiredCondition', desiredCondition.value);
  if (route.query.ref === 'e') {
    router.push({ name: 'e42', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e42' });
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseSelectButton, {
              placeholder: "業種を選択",
              isError: _unref(wishIndsctg1IdErrors).length > 0,
              modelValue: _unref(wishIndsctg1Name),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(wishIndsctg1Name) ? (wishIndsctg1Name).value = $event : null)),
              onClick: openIndsctg1Modal,
              onClear: _cache[1] || (_cache[1] = ($event: any) => (_unref(desiredCondition).wishIndsctg1Id = null))
            }, null, 8, ["isError", "modelValue"])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(wishIndsctg1IdErrors) }, null, 8, ["errors"]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseSelectButton, {
              placeholder: "業種を選択",
              modelValue: _unref(wishIndsctg2Name),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(wishIndsctg2Name) ? (wishIndsctg2Name).value = $event : null)),
              onClick: openIndsctg2Modal,
              onClear: _cache[3] || (_cache[3] = ($event: any) => (_unref(desiredCondition).wishIndsctg2Id = null))
            }, null, 8, ["modelValue"])
          ])
        ]),
        (maxWishIndsctgIndex.value >= 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(BaseSelectButton, {
                  placeholder: "業種を選択",
                  modelValue: _unref(wishIndsctg3Name),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(wishIndsctg3Name) ? (wishIndsctg3Name).value = $event : null)),
                  onClick: openIndsctg3Modal,
                  onClear: _cache[5] || (_cache[5] = ($event: any) => (_unref(desiredCondition).wishIndsctg3Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxWishIndsctgIndex.value >= 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(BaseSelectButton, {
                  placeholder: "業種を選択",
                  modelValue: _unref(wishIndsctg4Name),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(wishIndsctg4Name) ? (wishIndsctg4Name).value = $event : null)),
                  onClick: openIndsctg4Modal,
                  onClear: _cache[7] || (_cache[7] = ($event: any) => (_unref(desiredCondition).wishIndsctg4Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxWishIndsctgIndex.value >= 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(BaseSelectButton, {
                  placeholder: "業種を選択",
                  modelValue: _unref(wishIndsctg5Name),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(wishIndsctg5Name) ? (wishIndsctg5Name).value = $event : null)),
                  onClick: openIndsctg5Modal,
                  onClear: _cache[9] || (_cache[9] = ($event: any) => (_unref(desiredCondition).wishIndsctg5Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxWishIndsctgIndex.value >= 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(BaseSelectButton, {
                  placeholder: "業種を選択",
                  modelValue: _unref(wishIndsctg6Name),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(wishIndsctg6Name) ? (wishIndsctg6Name).value = $event : null)),
                  onClick: openIndsctg6Modal,
                  onClear: _cache[11] || (_cache[11] = ($event: any) => (_unref(desiredCondition).wishIndsctg6Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxWishIndsctgIndex.value < 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "button_text",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (maxWishIndsctgIndex.value++))
              }, "＋第" + _toDisplayString(maxWishIndsctgIndex.value + 1) + "希望を追加", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(BaseSelectButton, {
              placeholder: "職種を選択",
              modelValue: _unref(wishOcupctg1Name),
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(wishOcupctg1Name) ? (wishOcupctg1Name).value = $event : null)),
              isError: _unref(wishOcupctg1IdErrors).length > 0,
              onClick: openOcupctg1Modal,
              onClear: _cache[14] || (_cache[14] = ($event: any) => (_unref(desiredCondition).wishOcupctg1Id = null))
            }, null, 8, ["modelValue", "isError"])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(wishOcupctg1IdErrors) }, null, 8, ["errors"]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(BaseSelectButton, {
              placeholder: "職種を選択",
              modelValue: _unref(wishOcupctg2Name),
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(wishOcupctg2Name) ? (wishOcupctg2Name).value = $event : null)),
              onClick: openOcupctg2Modal,
              onClear: _cache[16] || (_cache[16] = ($event: any) => (_unref(desiredCondition).wishOcupctg2Id = null))
            }, null, 8, ["modelValue"])
          ])
        ]),
        (maxOcupctgIndex.value >= 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createVNode(BaseSelectButton, {
                  placeholder: "職種を選択",
                  modelValue: _unref(wishOcupctg3Name),
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(wishOcupctg3Name) ? (wishOcupctg3Name).value = $event : null)),
                  onClick: openOcupctg3Modal,
                  onClear: _cache[18] || (_cache[18] = ($event: any) => (_unref(desiredCondition).wishOcupctg3Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxOcupctgIndex.value >= 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createVNode(BaseSelectButton, {
                  placeholder: "職種を選択",
                  modelValue: _unref(wishOcupctg4Name),
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(wishOcupctg4Name) ? (wishOcupctg4Name).value = $event : null)),
                  onClick: openOcupctg4Modal,
                  onClear: _cache[20] || (_cache[20] = ($event: any) => (_unref(desiredCondition).wishOcupctg4Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxOcupctgIndex.value >= 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createVNode(BaseSelectButton, {
                  placeholder: "職種を選択",
                  modelValue: _unref(wishOcupctg5Name),
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(wishOcupctg5Name) ? (wishOcupctg5Name).value = $event : null)),
                  onClick: openOcupctg5Modal,
                  onClear: _cache[22] || (_cache[22] = ($event: any) => (_unref(desiredCondition).wishOcupctg5Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxOcupctgIndex.value >= 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createVNode(BaseSelectButton, {
                  placeholder: "職種を選択",
                  modelValue: _unref(wishOcupctg6Name),
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(wishOcupctg6Name) ? (wishOcupctg6Name).value = $event : null)),
                  onClick: openOcupctg6Modal,
                  onClear: _cache[24] || (_cache[24] = ($event: any) => (_unref(desiredCondition).wishOcupctg6Id = null))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxOcupctgIndex.value < 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "button_text",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (maxOcupctgIndex.value++))
              }, "＋第" + _toDisplayString(maxOcupctgIndex.value + 1) + "希望を追加", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            _createVNode(BaseSelectBox, {
              placeholder: "勤務地を選択",
              options: _unref(mstListPrefOptions),
              isError: _unref(wishWkarea1IdErrors).length > 0,
              modelValue: _unref(desiredCondition).wishWkarea1Id,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(desiredCondition).wishWkarea1Id) = $event)),
              hasCancelButton: "",
              onClear: _cache[27] || (_cache[27] = ($event: any) => (_unref(desiredCondition).wishWkarea1Id = null))
            }, null, 8, ["options", "isError", "modelValue"])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(wishWkarea1IdErrors) }, null, 8, ["errors"]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createVNode(BaseSelectBox, {
              placeholder: "勤務地を選択",
              options: _unref(mstListPrefOptions),
              modelValue: _unref(desiredCondition).wishWkarea2Id,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(desiredCondition).wishWkarea2Id) = $event)),
              hasCancelButton: "",
              onClear: _cache[29] || (_cache[29] = ($event: any) => (_unref(desiredCondition).wishWkarea2Id = null))
            }, null, 8, ["options", "modelValue"])
          ])
        ]),
        (maxWishWkareaIndex.value >= 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, [
                _createVNode(BaseSelectBox, {
                  placeholder: "勤務地を選択",
                  options: _unref(mstListPrefOptions),
                  modelValue: _unref(desiredCondition).wishWkarea3Id,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(desiredCondition).wishWkarea3Id) = $event)),
                  hasCancelButton: "",
                  onClear: _cache[31] || (_cache[31] = ($event: any) => (_unref(desiredCondition).wishWkarea3Id = null))
                }, null, 8, ["options", "modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxWishWkareaIndex.value >= 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createVNode(BaseSelectBox, {
                  placeholder: "勤務地を選択",
                  options: _unref(mstListPrefOptions),
                  modelValue: _unref(desiredCondition).wishWkarea4Id,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(desiredCondition).wishWkarea4Id) = $event)),
                  hasCancelButton: "",
                  onClear: _cache[33] || (_cache[33] = ($event: any) => (_unref(desiredCondition).wishWkarea4Id = null))
                }, null, 8, ["options", "modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (maxWishWkareaIndex.value < 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("button", {
                class: "button_text",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (maxWishWkareaIndex.value++))
              }, "＋第" + _toDisplayString(maxWishWkareaIndex.value + 1) + "希望を追加", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_60, [
        _hoisted_61,
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createVNode(BaseTextForm, {
                  modelValue: _unref(desiredCondition).wishAnnualIncomeNum,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(desiredCondition).wishAnnualIncomeNum) = $event)),
                  placeholder: "400",
                  maxlength: 4
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_66
            ])
          ]),
          _hoisted_67
        ]),
        _createVNode(ErrorMessage, { errors: _unref(wishAnnualIncomeNumErrors) }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _hoisted_69,
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createVNode(BaseSelectBox, {
              modelValue: _unref(selectedChangeDateValue),
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_isRef(selectedChangeDateValue) ? (selectedChangeDateValue).value = $event : null)),
              options: _unref(changeDateConvert),
              placeholder: "転職希望時期を選択"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _ctx.wishJobChangeDateIdDateValueErrors }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_72, [
        _hoisted_73,
        _createElementVNode("div", _hoisted_74, [
          _createVNode(BaseCheckbox, {
            class: "careersheet_input_layout_column_2_item",
            label: '正社員',
            value: false,
            modelValue: _unref(desiredCondition).empTypeFlg1,
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(desiredCondition).empTypeFlg1) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(BaseCheckbox, {
            class: "careersheet_input_layout_column_2_item",
            label: '契約社員',
            value: false,
            modelValue: _unref(desiredCondition).empTypeFlg5,
            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(desiredCondition).empTypeFlg5) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(empTypeFlg1Errors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_75, [
        _hoisted_76,
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createVNode(BaseTextareaForm, {
              name: "demand",
              rows: 10,
              maxCount: 2000,
              placeholder: "入力してください",
              modelValue: _unref(desiredCondition).demand,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(desiredCondition).demand) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(demandErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _createVNode(BaseButton, {
            theme: "tertiary",
            type: "button",
            onClick: transitionPreviousPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_83, [
          _createVNode(BaseButton, {
            theme: "primary",
            type: "button",
            onClick: transitionConfirmPage,
            disabled: !_unref(meta).valid
          }, {
            default: _withCtx(() => [
              _createTextVNode("確認する")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "業種選択",
      modelValue: _unref(desiredCondition).wishIndsctg1Id,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(desiredCondition).wishIndsctg1Id) = $event)),
      list: _unref(mstIndsctgRadioOnlyList),
      onClose: closeIndsctg1Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownIndsctg1Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "業種選択",
      modelValue: _unref(desiredCondition).wishIndsctg2Id,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(desiredCondition).wishIndsctg2Id) = $event)),
      list: _unref(mstIndsctgRadioOnlyList),
      onClose: closeIndsctg2Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownIndsctg2Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "業種選択",
      modelValue: _unref(desiredCondition).wishIndsctg3Id,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(desiredCondition).wishIndsctg3Id) = $event)),
      list: _unref(mstIndsctgRadioOnlyList),
      onClose: closeIndsctg3Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownIndsctg3Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "業種選択",
      modelValue: _unref(desiredCondition).wishIndsctg4Id,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(desiredCondition).wishIndsctg4Id) = $event)),
      list: _unref(mstIndsctgRadioOnlyList),
      onClose: closeIndsctg4Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownIndsctg4Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "業種選択",
      modelValue: _unref(desiredCondition).wishIndsctg5Id,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(desiredCondition).wishIndsctg5Id) = $event)),
      list: _unref(mstIndsctgRadioOnlyList),
      onClose: closeIndsctg5Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownIndsctg5Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "業種選択",
      modelValue: _unref(desiredCondition).wishIndsctg6Id,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_unref(desiredCondition).wishIndsctg6Id) = $event)),
      list: _unref(mstIndsctgRadioOnlyList),
      onClose: closeIndsctg6Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownIndsctg6Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "職種選択",
      modelValue: _unref(desiredCondition).wishOcupctg1Id,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(desiredCondition).wishOcupctg1Id) = $event)),
      list: _unref(mstOcupClassRadioList),
      onClose: closeOcupctg1Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownOcupctg1Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "職種選択",
      modelValue: _unref(desiredCondition).wishOcupctg2Id,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(desiredCondition).wishOcupctg2Id) = $event)),
      list: _unref(mstOcupClassRadioList),
      onClose: closeOcupctg2Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownOcupctg2Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "職種選択",
      modelValue: _unref(desiredCondition).wishOcupctg3Id,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(desiredCondition).wishOcupctg3Id) = $event)),
      list: _unref(mstOcupClassRadioList),
      onClose: closeOcupctg3Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownOcupctg3Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "職種選択",
      modelValue: _unref(desiredCondition).wishOcupctg4Id,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_unref(desiredCondition).wishOcupctg4Id) = $event)),
      list: _unref(mstOcupClassRadioList),
      onClose: closeOcupctg4Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownOcupctg4Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "職種選択",
      modelValue: _unref(desiredCondition).wishOcupctg5Id,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref(desiredCondition).wishOcupctg5Id) = $event)),
      list: _unref(mstOcupClassRadioList),
      onClose: closeOcupctg5Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownOcupctg5Modal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "職種選択",
      modelValue: _unref(desiredCondition).wishOcupctg6Id,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_unref(desiredCondition).wishOcupctg6Id) = $event)),
      list: _unref(mstOcupClassRadioList),
      onClose: closeOcupctg6Modal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownOcupctg6Modal.value]
    ])
  ], 64))
}
}

})